"use client";
import { motion } from "framer-motion";
import dynamic from "next/dynamic";
import AboutImage from "@/components/about_images";
const Star = dynamic(() => import("@/components/icons/star"));

const fadeLeft = {
  hidden: { opacity: 0, x: -100 },
  visible: { opacity: 1, x: 0, transition: { duration: 1 } },
};

const AboutKuppamMotion = ({ messages }) => {
  return (
    <section className="bg-green-8 px-1 text-justify sm:px-4 py-1 md:py-6 h-full w-full rounded-lg">
      {/* Title + Star */}
      <div className="w-full flex flex-col items-center group relative h-[110px]">
        <div className="absolute top-0 transition-all duration-1000 group-hover:translate-y-[65px]">
          <Star />
        </div>
        <h3 className="absolute bottom-0 transition-all duration-1000 group-hover:-translate-y-[65px] text-green-1 text-2xl md:text-3xl lg:text-4xl font-medium text-center mx-2">
          {messages.title}
        </h3>
      </div>

      {/* Content */}
      <div className="lg:flex lg:justify-between w-full font-extralight md:px-6 lg:px-8 mt-4 md:mt-10">
        <motion.div
          className="w-full lg:w-1/2 text-center md:text-left"
          initial="hidden"
          whileInView="visible"
          variants={fadeLeft}
          viewport={{ once: true }}
        >
          {messages.description.map((item, i) => (
            <p
              key={i}
              className="text-base lg:text-lg font-normal lg:font-semibold leading-relaxed mb-4"
              >
                {item}
              </p>
          ))}
        </motion.div>
        <div className="w-full lg:w-[40%]">
          <AboutImage />
        </div>
      </div>
    </section>
  );
};
export default AboutKuppamMotion;
